import React from "react";
import { TNA_TRACK_LOCATION_TYPES } from "../../utils/constants/track-location-constants";
import { TextField, TextFieldProps } from "@mui/material";
import { TnALocationCodeRef } from "../../models/tna-location-codes/tna-location-code-ref";
import { useTranslation } from "react-i18next";
import AutocompleteDropdown from "../../reusable-components/AutocompleteDropdown/AutocompleteDropdown";
import { TnALocationCodesApiService } from "../../services/tna-location-codes/tna-location-codes-api.service";
import { PropsFilter } from "../../models/api/props-filter";
import { ConfirmButton } from "../MyCalendar/AddEditMultipleClockings/WeekClockingsTable/styles";

interface Props {
  tnALocationCodeOrName: string;
  tnALocationCode: TnALocationCodeRef | null;
  handleChangelocationInput: (tnALocationCodeOrName: string, tnALocationCode: TnALocationCodeRef | null) => void;
  locationTrackingTypeId: string;
  employeeId: string;
  onBlur?: () => void;
  textFieldProps?: TextFieldProps;
}
const AddEditClockingLocation = ({
  tnALocationCodeOrName,
  tnALocationCode,
  handleChangelocationInput,
  locationTrackingTypeId,
  employeeId,
  onBlur,
  textFieldProps,
}: Props) => {
  const tRP = "components.add_edit_clocking_location";
  const { t } = useTranslation();

  const renderLocationInput = (): JSX.Element | null => {
    switch (locationTrackingTypeId) {
      case TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_LOCATION:
        return (
          <TextField
            sx={{
              width: "150px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px", // change to any radius
              },
            }}
            label={`${t(`${tRP}.enter_location_code`)}`}
            value={tnALocationCodeOrName}
            onChange={(e) => {
              const value = e.target.value;
              handleChangelocationInput(value ?? "", null);
            }}
            onBlur={onBlur}
            {...textFieldProps}
          />
        );

      case TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_WITH_FLAG:
        return (
          <TextField
            sx={{
              width: "150px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px", // change to any radius
              },
            }}
            label={`${t(`${tRP}.enter_location_code`)}`}
            value={tnALocationCodeOrName}
            onChange={(e) => {
              const value = e.target.value;
              handleChangelocationInput(value ?? "", null);
            }}
            onBlur={onBlur}
            {...textFieldProps}
          />
        );
      case TNA_TRACK_LOCATION_TYPES.ALLOW_ONLY_PREDEFINED:
        return (
          <AutocompleteDropdown
            labelKey={`${tRP}.select_location_code`}
            field="tnALocationCode"
            handleChange={(field, value) => handleChangelocationInput("", value)}
            serviceApi={new TnALocationCodesApiService()}
            required={true}
            selectedValue={tnALocationCode}
            sxProps={{ width: "100%", onBlur: onBlur, size: "small" }}
            propsFilter={{ employeeId: employeeId } as PropsFilter}
            textFieldProps={{ ...textFieldProps }}
            inputStyle={{ borderRadius: "5px", width: "150px" }}
          />
        );
      default:
        return null;
    }
  };
  return <>{renderLocationInput()}</>;
};

export default AddEditClockingLocation;
